import React from 'react'

export default function GridBanner() {
  return (
    <div>
        <section className='mt-5' >
    <img src="/images/mediciens.png" alt="" style={{ width: '100%' }}/>
        </section>
    </div>
  )
}
